document.addEventListener('DOMContentLoaded', () => {
  const vitallyUser = window.vitallyUser;

  if (!vitallyUser) {
    return;
  }

  const storageKey = vitallyUser.storageKey;
  if (sessionStorage.getItem(storageKey)) {
    return;
  }

  if (vitallyUser && vitallyUser.useMock) {
    window.Vitally = {
      init(apiKey, apiUrl) {
        console.log('Vitally.init called with apiKey:', apiKey, 'and apiUrl:', apiUrl);
      },
      user(data) {
        console.log('Vitally.user called with data:', data);
      },
      account(data) {
        console.log('Vitally.account called with data:', data);
      },
      organization(data) {
        console.log('Vitally.organization called with data:', data);
      },
      track(event, data) {
        console.log('Vitally.track called with event:', event, 'and data:', data);
      },
      nps(data) {
        console.log('Vitally.nps called with data:', data);
      },
    };
  }

  if (!sessionStorage.getItem(storageKey)) {
    let tracked = false;

    const {
      customerId,
      customerName,
      schoolId,
      schoolName,
      teacherId,
      teacherName,
      teacherEmail,
      teacherCreatedAt,
    } = vitallyUser || {};

    if (customerId) {
      window.Vitally.organization({
        organizationId: customerId,
        traits: { name: customerName },
      });
      tracked = true;
    }

    if (customerId && schoolId) {
      window.Vitally.account({
        accountId: schoolId,
        organizationId: customerId,
        traits: { name: schoolName },
      });
      tracked = true;
    }

    if (customerId && schoolId && teacherId) {
      window.Vitally.user({
        userId: teacherId,
        accountId: schoolId,
        organizationId: customerId,
        traits: {
          name: teacherName,
          email: teacherEmail,
          createdAt: teacherCreatedAt,
        },
      });
      tracked = true;
    }

    window.Vitally.nps('survey', {
      productName: 'Listenwise',
      delay: 5000,
    });

    if (tracked) {
      sessionStorage.setItem(storageKey, 'true');
    }
  }
});
